export function validateTeamsTranscriptFormat(text: string): boolean {
  try {
    const data = JSON.parse(text)

    // 必須トップレベルキーの存在チェック
    const requiredTopKeys = [
      'AccountId',
      'Categories',
      'Channel',
      'ContentMetadata',
      'ConversationCharacteristics',
      'CustomerMetadata',
      'JobStatus',
      'LanguageCode',
      'Participants',
      'Transcript',
      'Version',
    ]

    for (const key of requiredTopKeys) {
      if (!(key in data)) return false
    }

    // 型の簡易チェック
    if (typeof data.AccountId !== 'string') return false
    if (!Array.isArray(data.Participants)) return false
    if (!Array.isArray(data.Transcript)) return false
    if (typeof data.Version !== 'string') return false

    // Participants の構造確認
    const validParticipants = data.Participants.every(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (p: any) =>
        typeof p.ParticipantId === 'string' &&
        typeof p.ParticipantRole === 'string',
    )
    if (!validParticipants) return false

    // Transcript の構造確認
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const validTranscripts = data.Transcript.every((t: any) => {
      return (
        typeof t.BeginOffsetMillis === 'number' &&
        typeof t.EndOffsetMillis === 'number' &&
        typeof t.Content === 'string' &&
        typeof t.Id === 'string' &&
        typeof t.ParticipantId === 'string' &&
        Array.isArray(t.LoudnessScore)
      )
    })
    if (!validTranscripts) return false

    // Channel が VOICE 固定であること（任意チェック）
    if (data.Channel !== 'VOICE') return false

    return true
  } catch {
    // JSON.parse 失敗など
    return false
  }
}

export const calculateTeamsTranscriptDuration = (jsonText: string): number => {
  try {
    const data = JSON.parse(jsonText)

    // 優先：ConversationCharacteristics.TotalConversationDurationMillis
    const millis =
      data?.ConversationCharacteristics?.TotalConversationDurationMillis

    if (typeof millis === 'number' && millis > 0) {
      return Math.floor(millis / 1000) // 秒に変換して切り捨て
    }

    // フォールバック：Transcript の最初と最後の offset から推定
    if (Array.isArray(data?.Transcript) && data.Transcript.length > 1) {
      const first = data.Transcript[0].BeginOffsetMillis
      const last = data.Transcript[data.Transcript.length - 1].EndOffsetMillis
      if (typeof first === 'number' && typeof last === 'number') {
        return Math.floor((last - first) / 1000)
      }
    }

    return 0
  } catch {
    return 0
  }
}

/**
 * batch の TeamsParser が拾う発言時刻（秒）。batch は開始ミリ秒を秒に切り捨てて使う。
 * batch が Teams 形式として扱わない内容なら null を返す
 */
export const extractTeamsBeginSeconds = (jsonText: string): number[] | null => {
  let data: unknown
  try {
    data = JSON.parse(jsonText)
  } catch {
    return null
  }
  if (data == null || typeof data !== 'object' || !('Transcript' in data)) {
    return null
  }
  const transcript = data.Transcript
  if (
    !Array.isArray(transcript) ||
    transcript.length === 0 ||
    !transcript.every(
      (item) =>
        item != null &&
        typeof item === 'object' &&
        typeof item.BeginOffsetMillis === 'number' &&
        typeof item.Content === 'string' &&
        typeof item.ParticipantId === 'string',
    )
  ) {
    return null
  }
  return transcript.map((item) => Math.floor(item.BeginOffsetMillis / 1000))
}
